/*
  Redesign scroll-reveal. Gently fades and lifts the editorial blocks (How-to
  items, FAQ rows, Guides cards) into view as they are scrolled to. Enhancement
  only: if this never runs, if IntersectionObserver is missing, or if the visitor
  prefers reduced motion, every block stays fully visible. Scoped IIFE, no
  globals, one class toggled per element, observers released after reveal.
*/
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries, obs) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        entries[i].target.classList.add('is-revealed');
        obs.unobserve(entries[i].target);
      }
    }
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  function scan(scope) {
    // Only now do we commit to hiding the pre-reveal state, so the page is
    // fully visible if this script never runs.
    document.documentElement.classList.add('prc-reveal-init');
    var nodes = (scope || document).querySelectorAll('.prc-reveal:not(.is-revealed)');
    for (var i = 0; i < nodes.length; i++) {
      observer.observe(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  // Theme editor: reveal blocks in a section that was just reloaded.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
